import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';
import { IPublishedConnectionActions } from '../types/IPublishedConnectionActions';

export class GetPublishedConnectionActionsRequest extends Request<ISingleIdParams, IPublishedConnectionActions> {
  constructor(id: string) {
    super('getPublishedConnectionActions', { id: id });
  }
}
